import React, { useState, useEffect, useRef } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  Tooltip,
  Modal,
  notification,
  Tabs,
  Select,
} from "antd";
import { BarsOutlined, SendOutlined } from "@ant-design/icons";
import { odata } from "../Filters/Helper";

const ErpLogoDoubleCheckTransaction = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
    activeTab: "0",
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [order, setOrder] = useState("");

  useEffect(() => {
    if (props.Data) {
      setTableData({
        data: props.Data,
        total: props.Data.length,
        loading: false,
      });
    }
  }, []);

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };

  const onConfirmSuccessfulExport = () => {
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    if (selectedRowsData.some((row) => row.isDuplicateTransaction)) {
      notification.error({
        message: "Seçili hesap hareketleri içerisinde kopya hareketler var.",
        duration: 3,
      });
      isSuccess = false;
    }
    if (isSuccess) {
      selectedRowsData.map((item) => {
        if (item.firmClassId === null) {
          item.firmClassId = "00000000-0000-0000-0000-000000000000";
        }
        if (item.firmId === null) {
          item.firmId = "00000000-0000-0000-0000-000000000000";
        }
      });

      RequestHandler.post(
        "/ErpAccountTransaction/SetSuccessfulTransfer",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          var lastData = tableData.data.filter(
            (row) => !selectedRowsData.includes(row)
          );

          setTableData({
            data: lastData,
            total: lastData.length,
            loading: false,
          });
        }
      });
    }
  };

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Tutar",
      dataIndex: "amountString",
      editable: true,
      render: (data) => <span style={{ whiteSpace: "nowrap" }}>{data}</span>,
    },
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Cari",
      dataIndex: "firmId",
      width: "15%",
      render: (data, row, index) => (
        <Select
          allowClear
          showSearch
          defaultValue={data ?? undefined}
          disabled={true}
          style={{ width: "100%" }}
          dropdownStyle={{ minWidth: "50%" }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
        >
          {data && (
            <Select.Option
              key={row.firmId}
              value={row.firmId}
              firmName={row.firmName}
              firmClassName={row.firmClassName}
            >
              {row.firmBranchNumber
                ? `${row.firmName} (${row.firmBranchNumber})`
                : row.firmName}
            </Select.Option>
          )}
        </Select>
      ),
    },
    {
      title: "Mükerrer Durumu",
      dataIndex: "isDoubleCheckedTransaction",
      render: (data) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {data === true ? "Mükerrer" : "Logo'da kayıt yok."}
        </span>
      ),
    },
    {
      title: "Uyarı",
      dataIndex: "warningMessage",
    },
  ];

  const onConfirmExport = () => {
    let isSuccess = true;

    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    // tenantAccountErpCode valuesu olmayan bir tenant account hareketi seçili ise
    if (selectedRowsData.some((row) => !row.tenantAccountErpCode)) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde 'Erp Kodu' olmayan Hesaba ait kayıtlar var.",
        duration: 3,
      });
      isSuccess = false;
    }

    // erp valuesu olan bir firmClass ve cari seçili değilse
    if (
      !selectedRowsData.every(
        (row) =>
          row.firmClassId !== "00000000-0000-0000-0000-000000000000" &&
          row.firmId &&
          row.firmId !== "00000000-0000-0000-0000-000000000000"
      )
    ) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde 'Tip' veya 'Cari' seçilmemiş kayıtlar var.",
        duration: 3,
      });
      isSuccess = false;
    }

    // firmBranchNumber valuesu olmayan bir firm seçili ise
    if (selectedRowsData.some((row) => !row.firmBranchNumber)) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde 'Cari Kodu' olmayan Cari kayıtları var.",
        duration: 3,
      });
      isSuccess = false;
    }

    if (isSuccess) {
      RequestHandler.post("/ErpAccountTransaction", selectedRowsData).then(
        (response) => {
          if (response.success) {
            var lastData = tableData.data.filter(
              (row) => !selectedRowsData.includes(row)
            );
            setTableData({
              data: lastData,
              total: lastData.length,
              loading: false,
            });
          } else {
            isSuccess = false;
          }
        }
      );
    }
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> Mükerrer Hareket Listesi
          </p>
        </Col>
        <Col xs={24} md={6} lg={4} style={{ textAlign: "right" }}>
          <Popconfirm
            title="Aktarıldı olarak işaretlensin mi?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmSuccessfulExport}
          >
            <Button
              disabled={selectedRowKeys.length < 1}
              style={{ marginBottom: 0, marginRight: 15 }}
            >
              <SendOutlined /> Aktarıldı Yap
            </Button>
          </Popconfirm>
        </Col>
        <Col xs={24} md={6} lg={4} style={{ textAlign: "right" }}>
          <Popconfirm
            title="Aktarmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmExport}
          >
            <Button
              type="primary"
              disabled={selectedRowKeys.length < 1}
              style={{ marginBottom: 0 }}
            >
              <SendOutlined /> Erp'ye Aktar
            </Button>
          </Popconfirm>
        </Col>
      </Row>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            rowSelection={{
              selectedRowKeys: selectedRowKeys,
              onChange: onTableSelectChange,
            }}
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
              showSizeChanger: true,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default ErpLogoDoubleCheckTransaction;
